import { inject, Injectable, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Log } from '@core/services/config/app-config.service';
import { filter } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CartSidebarService {
    // Stato del sidebar usando signals
    private isOpenSignal = signal(false);
    readonly isVisible = this.isOpenSignal.asReadonly();
    private router = inject(Router);

    constructor() {// Ascolta gli eventi di navigazione: quando la navigazione termina con successo, chiude la sidebar
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            this.close();
        });
    }

    open(): void {
        this.isOpenSignal.set(true);
    }

    close(): void {
        this.isOpenSignal.set(false);
    }

    toggle(): void {
        this.isOpenSignal.update(value => !value);
    }

    /**
     * Verifica se il sidebar è aperto
     * @returns true se il sidebar è aperto, false altrimenti
     */
    isOpen(): boolean {
        return this.isOpenSignal();
    }

}

